module.exports = __webpack_public_path__ + "static/desktop/img/template-jp.6f2b43a1.png";